<template>
	<v-container fluid>
		<!--table -->
		<div v-if="!loading">
			<!--table head-->
			<v-divider class="mt-4" color="black" />
			<v-row class="subtitle-2 mx-4" no-gutters>
				<v-col v-for="(item, i) in headers" :key="i"
					class="text-pre-wrap" 
					:class="item.style">
					{{ `${item.title}` | localize }}
				</v-col>
			</v-row>
			<v-divider color="black" />
			<div v-if="products?.length > 0">
				<!-- products tab -->
				<v-expansion-panels multiple v-model="tab">
					<v-expansion-panel v-for="item in modelsByTrademark" :key="item.trademarkId">
						<v-expansion-panel-header class="secondary--text" color="#E8EAF6">
							<!-- trademark-->
							{{'trademark' | localize }}: {{ item.trademark }}	
						</v-expansion-panel-header>
						<v-expansion-panel-content class="body-2">
							<!--- models -->
							<div v-for="product in item.models" :key="product.id">
								<v-row no-gutters>
									<v-col class="text-left">{{ product.model }}</v-col>
									<v-col class="text-center">{{ stringMonth(product.available_from) }}</v-col>
									<v-col class="text-center">{{ stringMonth(product.available_till) }}</v-col>
									<v-col class="text-center">{{ status(product) }}</v-col>
									<v-col class="text-center">{{ product.material }}</v-col>
									<v-col class="text-center">{{ product.manufacturing }}</v-col>
									<v-col class="text-center">{{ `${product.design_type}` | localize }}</v-col>
									<v-col class="text-center">{{ product.design }}</v-col>
									<v-col class="text-center">{{ product.variations }}</v-col>

									<v-col v-if="product.advanced_feature" class="text-justify">
										{{ `${product.advanced_feature}` | localize }}
									</v-col>
									<v-col v-else class="text-center"> - </v-col>

									<v-col class="text-center">{{ round(product.unit_cost) }}</v-col>
									<v-col class="text-center">{{ formatNumber(product.investments) }}</v-col>

									<v-col v-if="status(product) == 'available' || 'disponibil' || 'доступный'" class="text-right">
										<upgrade-model :product="product" />
										<delete-product :product="product" />
									</v-col>
									<v-col v-else class="text-right">
										<delete-product :product="product" />
									</v-col>
								</v-row>
								<v-divider />
							</div>
							<!--add model component-->
							<v-row class="my-4 mx-8" justify="end">
								<add-model :brand="item" />
							</v-row>

						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</div>
			<div class="my-4 ml-12 text-start">
				<add-brand />
			</div>
		</div>
		<!--Loader -->
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row> 
	</v-container>
</template>
<script>
import localizeFilter from '../../../filters/localize.filter.js';
import { getMonth, localeNumber, roundNumber } from '../../../functions/common';
import Loader from '../../../layouts/Loader.vue';

export default {
	data () {
		return {
			headers: [
				{ title: 'Product', style: 'text-left' },
				{ title: 'Available in (month)', style: 'text-center' },
				{ title: 'Available until (month)', style: 'text-center' },
				{ title: 'Status', style: 'text-center' },
				{ title: 'Material level', style: 'text-center' },
				{ title: 'Manufacturing level', style: 'text-center' },
				{ title: 'Design type', style: 'text-center' },
				{ title: 'Design level', style: 'text-center' },
				{ title: 'Model variations', style: 'text-center' },
				{ title: 'Functional expansion', style: 'text-center' },
				{ title: 'Unit cost $', style: 'text-center' },
				{ title: 'R&D spending $', style: 'text-center' },
				{ title: 'Actions', style: 'text-center' },
			],
			tab: [0],
		}
	},
	computed: {
		loading() {
			return this.$store.getters.loading
		},
		locale() {
			return this.$store.getters.locale;
		},
		team() {
			return this.$store.getters.team;
		},
		game() {
			return this.$store.getters.game;
		},
		products() {
			return this.$store.getters.products;
		},
		modelsByTrademark() {
			const trademarks = [];
			if (this.products?.length > 0) {
				trademarks.push(
					{
						trademarkId: this.products[0].trademarkId,
						trademark: this.products[0].trademark.name,
						models: [this.products[0]]
					}
				)
				for (let i = 1; i < this.products.length; i++) {
					const inArr = trademarks.find(tr => tr.trademarkId === this.products[i].trademarkId)
					if (inArr) {
						inArr.models.push(this.products[i]);
					}
					else {
						trademarks.push(
							{
								trademarkId: this.products[i].trademarkId,
								trademark: this.products[i].trademark.name,
								models: [this.products[i]]
							}
						)
					}
				}
			}
			return trademarks;
		}
	},
	methods: {
		status(product) {
			if (product.available_till < 12) 
				return localizeFilter(`will be upgraded`)
			else if (product.available_from > 1) 
				return localizeFilter(`in progress`)
			else return localizeFilter('available')
		},
		shortName(str) {
			let res = ''
			if (str) {
				res = str.substr(0, 7) + '...';
			}
			return res;	
		},
		stringMonth(num) {
			return getMonth(num);
		},
		formatNumber(num) {
			return localeNumber(num, this.locale);
		},
		round(num1) {
			return roundNumber(num1, 1);
		}
	},
	components: { 
		Loader,
		AddModel: () => import('../../../components/team/products/addModel.vue'), 
		UpgradeModel: () => import('../../../components/team/products/upgradeModel.vue'), 
		DeleteProduct: () => import('../../../components/team/products/deleteModel.vue'), 
		AddBrand: () => import('../../../components/team/products/addBrand.vue')
	},
	async created() {
		
		if (this.game && this.team) {
			
			if (this.products == null) {

				const params = {
					gameId: this.game.id,
					round: this.game.round,
					teamId: this.team.id,
				}
			
				try {
					await this.$store.dispatch('fetchTeamProducts', params);
				} catch (error) {
					await this.$store.dispatch('setError', error.message)	
				}
			}
		}
	}
}
</script>